export default function requiredEnvironmentVariable(name) {
  const value = process.env[name];

  if (!value) {
    throw new Error(`Required environment variable '${name}' must be set`);
  }

  return value;
}
